import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      style={{
        background: "#040404",
        borderTop: "1px solid rgba(245,245,245,0.06)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 flex flex-col md:flex-row gap-6 items-center justify-between">
        {/* Logo */}
        <Link to="/">
          <Logo size="sm" forceDark />
        </Link>

        {/* Navigation Links */}
        <div className="flex gap-8 text-xs flex-wrap justify-center md:justify-end">
          <Link
            to="/for-tenants"
            style={{ color: "rgba(245,245,245,0.3)" }}
            className="hover:text-white transition-colors"
          >
            For Tenants
          </Link>
          <Link
            to="/for-landlords"
            style={{ color: "rgba(245,245,245,0.3)" }}
            className="hover:text-white transition-colors"
          >
            For Landlords
          </Link>
          <Link
            to="/for-brokers"
            style={{ color: "rgba(245,245,245,0.3)" }}
            className="hover:text-white transition-colors"
          >
            For Brokers
          </Link>
          <Link
            to="/about"
            style={{ color: "rgba(245,245,245,0.3)" }}
            className="hover:text-white transition-colors"
          >
            About
          </Link>
          <Link
            to="/contact"
            style={{ color: "rgba(245,245,245,0.3)" }}
            className="hover:text-white transition-colors"
          >
            Contact
          </Link>
          <Link
            to="/login"
            style={{ color: "rgba(245,245,245,0.3)" }}
            className="hover:text-white transition-colors"
          >
            Login
          </Link>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        style={{
          borderTop: "1px solid rgba(245,245,245,0.06)",
          padding: "1.5rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        <p className="text-xs" style={{ color: "rgba(245,245,245,0.2)" }}>
          © 2025 Orello. All rights reserved.
        </p>
        <div className="flex gap-6 text-xs">
          <Link
            to="/terms"
            style={{ color: "rgba(245,245,245,0.2)" }}
            className="hover:text-white transition-colors"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            style={{ color: "rgba(245,245,245,0.2)" }}
            className="hover:text-white transition-colors"
          >
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
}
